import { render, staticRenderFns } from "./AddNumber.vue?vue&type=template&id=513aec7c&"
import script from "./AddNumber.vue?vue&type=script&lang=js&"
export * from "./AddNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports